module.exports = __webpack_public_path__ + "img/home.f0208b99.svg";